module.exports = __webpack_public_path__ + "static/media/logo-fsh.584c38aa.png";